import { useQuery } from "@tanstack/react-query";
import invariant from "shared/utils/invariant";
import { queryClient } from "../../../shared/api/queryClient";
import { getModuleTemplate } from "../api/getModuleTemplate";

export const useModuleTemplateQuery = (moduleId: string | null) => {
  return useQuery({
    queryKey: ["moduleTemplate", moduleId],
    queryFn: async () => {
      invariant(moduleId);
      return getModuleTemplate(moduleId);
    },
    enabled: !!moduleId,
    staleTime: 0,
  });
};

export const invalidateModuleTemplate = async (moduleId: string | null) => {
  await queryClient.invalidateQueries({
    queryKey: ["moduleTemplate", moduleId],
  });
};
